import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { DatePipe } from '@angular/common';
import { _ } from 'underscore';
import { holidays } from '../../../../../assets/holidays';
import {IMyDpOptions, IMyDate} from 'mydatepicker';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q6',
  templateUrl: './r-q6.component.html',
  styleUrls: ['./r-q6.component.css', '../residential-question.component.css'],
  providers: [DatePipe],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ6Component implements OnInit {

  @Input() data: any;
  priorAnswer;

  date;
  question;
  questions;
  user_bot = false;
  userResponses = [];
  index;
  questionObj;
  oldDate;
  hgHolidays;
  deviceWidth;
  ans_conf_date;
  prevDate;
  public datemodel: any;
  disableDays: Array<IMyDate> = [];
  highLightdates: Array<IMyDate> = [];
  disableAfter: IMyDate;
  public myDatePickerOptions: IMyDpOptions;
  timer;

  constructor(private residentialService: ResidentialService, private datePipe: DatePipe) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
    this.hgHolidays = holidays.hgHolidays;
    for ( let i = 0; i < this.hgHolidays.length; i++) {
      this.disableDays.push({ year: this.hgHolidays[i].year, month: this.hgHolidays[i].month, day: this.hgHolidays[i].day});
    }
    const dt = new Date().setDate(new Date().getDate() + 60 );
    this.disableAfter = { year: new Date(dt).getFullYear(), month: new Date(dt).getMonth() + 1, day: new Date(dt).getDate()};
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 0);
    }
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    // check the flow is renewal
    if (this.residentialService.questionFlowType === 'renewal') {
      this.residentialService.messageService({ 'nextId': '0014' });
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }
    this.myDatePickerOptions = {
      // other options...
      dateFormat: 'mm-dd-yyyy',
      disableSince: this.disableAfter,
      disableDays: this.disableDays,
      disableWeekends: true,
      disableUntil : { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() - 1},
      showInputField	: false,
      highlightDates : this.highLightdates,
      showClearDateBtn: false
    };
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      this.oldDate = _.findWhere(this.userResponses, { 'res_question_id': '005' });
      if (!_.isEmpty(this.oldDate)) {
        this.date = this.oldDate.fieldValue;
        this.datemodel = {date: { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: this.date.getDate()}};
        this.prevDate = this.datemodel.date.month + ' / ' + this.datemodel.date.day + ' / ' + this.datemodel.date.year;
        this.highLightdates.push(this.datemodel.date);
      }
      const obj = _.findWhere(this.userResponses, { 'res_question_id': this.data });
      if (!_.isEmpty(obj)) {
        this.date = obj.fieldValue;
        this.ans_conf_date = this.datemodel.date.month + ' / ' +  this.datemodel.date.day + ' / ' + this.datemodel.date.year;
        this.prevDate = this.ans_conf_date;
        this.user_bot = true;
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    }
    setInterval(() => {
      if ( (new Date().getUTCHours() - 6) >= 13) {
        this.disableDays.push({ year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate()});
      }
    }, 1000);
    // this.residentialService.currentMessage.subscribe(message => {
    //   if (message['dateOfSwitch_sp']) {
    //     let type = localStorage.getItem('type');
    //     this.priorAnswer = type + " " + this.datePipe.transform(message['dateOfSwitch_sp'], 'yyyy-MM-dd');
    //   }
    // });
  }

  // To update the date backwards
  dateChanged() {
    this.date = new Date(this.datemodel.date.year, this.datemodel.date.month - 1, this.datemodel.date.day);
    this.ans_conf_date = this.datemodel.date.month + ' / ' +  this.datemodel.date.day + ' / ' + this.datemodel.date.year;
    this.prevDate = this.ans_conf_date;
    // console.log.log(this.datemodel);
    const Obj = { 'res_question_id': '005', 'fieldName': 'dateOfSwitch_sp', 'fieldValue': this.date };
    this.residentialService.updateResponses(Obj);
    this.user_bot = true;
    if (this.deviceWidth < 768) {
      this.goNext();
    }
  }

  next() {
    // check date and confirmdate
    const oldDate = this.datePipe.transform(this.oldDate.fieldValue, 'yyyy-MM-dd');
    if (_.isEmpty(this.datemodel)) {
      // console.log.log(this.datemodel);
      alert('Please select date!');
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
    } else {
      const Obj = { 'res_question_id': this.data, 'fieldName': 'confirmedDate', 'fieldValue': this.date };
      this.residentialService.updateResponses(Obj);
      this.residentialService.messageService({ 'currentId': this.data });
    }
  }

}
